export default __webpack_public_path__ + "static/media/service.efcc16d9.jpg";